import { changeFixedWeekdays } from "@/pages/daycare-hotel/plans/useDaycarePlanContractDays";
import { replaceWeekday, weekdayOfDate } from "@/lib/daycare-hotel/offDayPreview";
import { cancelStayDay } from "./cancelStayDay";

/** O que o atendente escolheu para um dia fora do plano. */
export type OffDayResolution =
  | { option: "change_plan"; weekdayOut: number }
  | { option: "swap_week"; dayIdOut: string }
  | { option: "ad_hoc"; packageContractId: string | null }
  | { option: "move_once" };

export interface ApplyOffDayResolutionInput {
  contractId: string;
  fixedWeekdays: number[];
  targetDate: string;
  /** Mantido para os chamadores; a RPC confere a quantidade de dias sozinha. */
  usageLimit?: number | null;
  resolution: OffDayResolution;
}

export interface OffDayOutcome {
  /**
   * `create`: grava uma reserva nova na data. `move`: move a diária remarcada.
   * `none`: nada mais a fazer — mudar os dias já gera a diária pelo plano, e
   * criar reserva ou mover por cima duplicaria o dia.
   */
  next: "create" | "move" | "none";
  planChoice: "existing" | "avulso" | null;
  contractId: string | null;
}

export async function applyOffDayResolution({
  contractId,
  fixedWeekdays,
  targetDate,
  resolution,
}: ApplyOffDayResolutionInput): Promise<OffDayOutcome> {
  switch (resolution.option) {
    case "change_plan":
      await changeFixedWeekdays({
        contractId,
        weekdays: replaceWeekday(fixedWeekdays, resolution.weekdayOut, weekdayOfDate(targetDate)),
      });
      return { next: "none", planChoice: null, contractId: null };
    case "swap_week":
      await cancelStayDay({ dayId: resolution.dayIdOut, contractId });
      return { next: "create", planChoice: "existing", contractId };
    case "ad_hoc":
      return resolution.packageContractId
        ? { next: "create", planChoice: "existing", contractId: resolution.packageContractId }
        : { next: "create", planChoice: "avulso", contractId: null };
    case "move_once":
      return { next: "move", planChoice: "existing", contractId };
  }
}
